import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosClient, { axiosWithAuth } from '@/services/axios';
import { reset } from '../reducers/auth-reducer';
import { resetCartInformation } from '../reducers/carts-reducer';
import { resetShippingInfoForAuthenticateUser } from '../reducers/shipping-address-reducer';
import { resetPlaceOrderInfoAfterLogout } from '../reducers/checkout-summary-reducer';
import { resetPlaceOrderStateForNextCheckout } from '../reducers/place-order-reducer';
import { fetchPastOrderList } from './orders-thunk';
import { setHasPastOrder } from '../reducers/orders-reducer';
import { getUserAddresses } from './shipping-address-thunk';
import { resetSpinTheWheelForLogout } from '../reducers/spin-the-wheel-reducer';

// Async Thunk to Fetch User Profile
export const getUser = createAsyncThunk(
  'auth/getUser',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosWithAuth().get(
        `/api/auth/profile/get-profile`,
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const updateUser = createAsyncThunk(
  'auth/updateUser',
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axiosWithAuth().patch(
        `/api/auth/profile/update`,
        data,
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const updateUserPhoto = createAsyncThunk(
  'auth/updateUserPhoto',
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axiosWithAuth(getState().auth.accessToken).post(
        `/api/auth/profile/photo/update`,
        data,
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const getOtp = createAsyncThunk(
  'auth/login',
  async ({ login }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(`/api/auth/otp/login`, {
        login,
      });
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const verifyOtp = createAsyncThunk(
  'auth/verify',
  async ({ otp }, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axiosClient.post(`/api/auth/otp/verify`, {
        referenceId: getState().auth.OTPInfo?.referenceId,
        otp,
      });
      setTimeout(() => dispatch(getUser()), 500);
      setTimeout(() => {
        dispatch(getUserAddresses());
      }, 500);
      setTimeout(() => dispatch(fetchPastOrderList()), 600);
      setTimeout(() => {
        const { isLoggedIn, onLoginSuccess } = getState().auth;
        if (isLoggedIn && onLoginSuccess) {
          onLoginSuccess();
        }
      }, 700);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const resendOtp = createAsyncThunk(
  'auth/otp/resend',
  async ({ extendExpiry = 300 }, { getState, rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        `/api/auth/otp/resend?${getState().auth.OTPInfo?.referenceId}`,
        { extendExpiry, referenceId: getState().auth.OTPInfo?.referenceId },
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const refreshTokenCall = createAsyncThunk(
  'auth/refresh',
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axiosClient.post(`/api/auth/refresh-token`);
      return response.data;
    } catch (e) {
      dispatch(reset());
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const logoutOtp = createAsyncThunk(
  'auth/logout',
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      dispatch(reset());
      dispatch(resetCartInformation());
      dispatch(resetShippingInfoForAuthenticateUser());
      dispatch(resetPlaceOrderInfoAfterLogout());
      dispatch(resetPlaceOrderStateForNextCheckout());
      dispatch(setHasPastOrder(false));
      dispatch(resetSpinTheWheelForLogout());

      const response = await axiosClient.get(`/api/auth/logout`);

      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);
